import type { PreOrderMessage } from "@stockline/shared/types/orders/pre-order-message"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_MESSAGE_TABLE } from "./db"

export const preOrderMessageConfig: OfflineResourceConfig<PreOrderMessage> = {
  // Must match EVENT_TYPE_TO_RESOURCE in apps/api/src/sse/types.ts
  // (kebab-plural). Mismatch = SSE silently dropped.
  name: "pre-order-messages",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // HOT via the parent pre-order (server floor by parent JOIN). STK-1322.
  tier: "hot",
  windowedBy: "pre-orders",
  window: { days: 30 },
  endpoints: {
    full: "/api/v2/pre-order-messages",
    // Read-only resource — server is the sole writer (Python pre-order +
    // recap services). The push URL is required by the engine but never
    // hit because we never enqueue mutations for this resource.
    delta: "/api/v2/pre-order-messages/changes",
    push: "/api/v2/pre-order-messages/changes",
  },
  tableName: PRE_ORDER_MESSAGE_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    preOrderId: "preOrderId",
    messageId: "messageId",
    chatId: "chatId",
    deletedAt: "deletedAt",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
